<template>
  <div class="free-insurance-box">
    <!--banner图-->
    <div class="banner-img-box">
      <img :src="cdnresources + '/prod/images/xiangaibao/banner2.png'" />
      <div class="marqueeBox">
        <marqueeVue class="marqueeVue" :dataList="this.dataList"></marqueeVue>
      </div>
      <!-- <component class="countDown" :is="modules['CountDown']"></component> -->
      <div @click="gotoSubmit">
        <img class="lijitoubao" :src="cdnresources + '/prod/images/xiangaibao/lijitoubao.png'" />
        <img class="point" :src="cdnresources + '/prod/images/xiangaibao/handsImg.png'" />
      </div>
    </div>

    <van-tabs scrollspy background="#FFFFFF" line-width="20%" color="#F6303B" title-active-color="#F6303B"
      title-inactive-color="#4F4F4F" @change="onActive" sticky ref="scrollTab">
      <van-tab title="产品特色">
        <!-- 保障内容 -->
        <div class="baozhangneirongcss">
          <div class="baozhangtop">
            <div class="baozhang_box">
              <div class="left">参保时间：</div>
              <div class="right">
                <div>2022年07月25日-2022年09月30日</div>
                <div>2022年10月01日-2022年11月30日</div>
                <div>2022年12月01日-2022年12月31日</div>
              </div>
            </div>
            <div class="baozhang_box">
              <div class="left">参保人群：</div>
              <div class="right">
                湖南省基本医疗保险的参保人及新市民。
              </div>
            </div>
            <div class="baozhang_box">
              <div class="left">保障期限：</div>
              <div class="right">
                <div>2022年10月01日-2023年09月30日</div>
                <div>2022年12月01日-2023年11月30日</div>
                <div>2023年01月01日-2023年12月31日</div>
                <div>继续参保客户的保障期间按原保单截止日自动顺延一年</div>
              </div>
            </div>
          </div>
          <component :is="modules['supply']" :className="'ensure-btn'" :imgUrl="
  `${cdnresources}/prod/images/xiangaibao/baozhangneirong.png`
"></component>
          <img :src="cdnresources + '/prod/images/xiangaibao/xiangqing.png'" class="title_img"
            @click="guaranteehide = true" />
        </div>
        <div class="product_List">
          <img class="product_img" :src="cdnresources + '/prod/images/xiangaibao/productImg0.png'" />
          <img class="product_img" :src="cdnresources + '/prod/images/xiangaibao/productImg1.png'" />
          <div class="medicine">
            <img class="product_img" :src="cdnresources + '/prod/images/xiangaibao/productImg2.png'" />
            <img class="medicinebtn" @click="teyaoqingdanclick"
              :src="cdnresources + '/prod/images/xiangaibao/medicinebtn.png'" />
          </div>
          <img class="product_img" :src="cdnresources + '/prod/images/xiangaibao/productImg3.png'" />
        </div>
      </van-tab>
      <van-tab title="理赔案例">
        <!-- 理赔案例 -->
        <van-tabs v-model="caseActive" class="caseTabs" background="#FFFFFF" color="#F6303B"
          title-active-color="#F61F1E" title-inactive-color="#888888">
          <van-tab title="健康体案例" name="case1">
            <img class="product_img" :src="cdnresources + '/prod/images/xiangaibao/caseImg1.png'" />
          </van-tab>
          <van-tab title="既往症案例" name="case2">
            <img class="product_img" :src="cdnresources + '/prod/images/xiangaibao/caseImg2.png'" />
          </van-tab>
          <van-tab title="CAR-T治疗案例" name="case3">
            <img class="product_img" :src="cdnresources + '/prod/images/xiangaibao/caseImg3.png'" />
          </van-tab>
        </van-tabs>
      </van-tab>
      <div class="claim_des">
        <div class="claim_des_title">
          <div class="claim_des_line"></div>
          <div>理赔说明</div>
        </div>
        <van-tabs v-model="claimActive" title-active-color="#FFFFFF" title-inactive-color="#F61F1E">
          <van-tab :title-class="claimActive == index ? 'claimTabActive' : 'claimTab'" :title="item.title"
            v-for="(item, index) in claimList" :key="index">
            <div class="claim_des_text">{{ item.text }}</div>
          </van-tab>
        </van-tabs>
      </div>
      <van-tab title="常见问题">
        <Common-Problem :problem="datalist.commonProblem" />
      </van-tab>
      <van-tab title="我要投保" id="a">
        <Insured-Information ref="formData" @getPeopleNumber="getNum" />
      </van-tab>
    </van-tabs>
    <!-- 底部公司 -->
    <Bottom-Company />
    <term-agreement id="termAgree" @clauseck="consentclause" :baoxiancode="baosi" :xfzIndex="getXfzIndex()" />
    <div class="footer">
      <div class="submit_btn">
        <div class="btn_left">
          <router-link class="left-img" :to="{ path: '/user-policy/all' }" v-if="DeviceInfo.env === 'wechat'">
            <img src="~@/assets/img/insu_detail/orderIcon.png" alt="" />
          </router-link>
          <div class="left-img" v-track-event="
  '跳转至在线客服页面,点击,用户点击图标跳转至在线客服页面'
">
            <img src="@/assets/img/insu_detail/kefuIcon.png" @click="goConsult" id="Online_Service" />
          </div>
        </div>
        <div class="total">
          <div class="money">
            <span>￥</span>
            <span>{{ peopleNum | calculatemoney }}</span>
            <span>元/年</span>
          </div>
          <div class="price">
            您共计参保<span>{{ peopleNum }}</span>人
          </div>
        </div>
        <van-button block :loading="loading" loading-type="spinner" class="btn" @click="testFn"
          id="Immediate_Insurance">立即参保</van-button>
      </div>
    </div>
    <van-dialog class="dialogContainer" v-model="DialogH5Flag" title="温馨提示">
      <div class="DialogH5Box" v-if="aliTip">
        <div class="dialogclass">
          <span class="alitip">
            查询到参保人：{{
    errResPerson
}}，名下已有订单，请核实是否参保成功，如已参保，无需重复购买。如未参保，可15分钟后重试。
          </span>
          <div class="alitip_zhu">(核实方式：投保页左下角联系在线客服)</div>
        </div>
      </div>
      <div class="DialogH5Box" v-else-if="changshaTip">
        <div class="dialogclass">
          <span class="alitip">
            参保人：{{
    errResPerson
}}；已有订单，如已参保，无需重复购买，如未参保成功，可在24小时后重试，或联系「在线客服」进行关闭订单后再次投保。
          </span>
        </div>
      </div>
      <div class="DialogH5Box" v-else>
        <div class="dialogclass">
          <span>
            参保人：{{
    errResPerson
}}；已有订单，如已参保，无需重复购买，如未参保，
            可前往“湖南爱民保”公众号个人中心-订单列表完成支付，谢谢！
          </span>
        </div>
        <div class="imgclass">
          <img src="@/assets/img/pay/wxCode.png" />
        </div>
        <span>扫码关注</span>
      </div>
    </van-dialog>
    <van-popup v-model="showInfo" round class="info_popup" @closed="closedInfo">
      <div class="info_title">
        信息确认
        <img @click="closedInfo" class="closeIcon" src="~@/assets/img/insu_detail/closeIcon.png" alt="" />
      </div>
      <div class="info_des">
        需验证缴费人的身份三要素信息是否一致
      </div>
      <div class="infoList">
        <div class="info_item" v-for="(item, index) in infoList" :key="index">
          <div class="item_left">{{ item.title }}</div>
          <div class="item_right">
            <div>
              {{ item.value }}
              <span v-if="item.code == 'payAmount'">元</span>
            </div>
            <van-button v-if="item.code == 'appntMobileNumber'" size="mini" round :color="
  'linear-gradient(360deg, #FF5248 0%, #FFF1A5 99%, #FFFFFF 100%)'
" :disabled="codeDisabled" @click="getcode">{{ veriTipText }}</van-button>
          </div>
        </div>
      </div>
      <vue-sms-check-code title="请输入验证码" :codeNum="6" :is-error="isError" error-color="#D81A1A" @finish="getSmsCode" />
    </van-popup>
    <!--分享图-->
    <div class="share-button" v-if="DeviceInfo.env === 'wechat'" @click="showShare = true">
      <img id="Immediate_Insure_Share" src="../../assets/img/insu_detail/share-tip.png" alt="分享图标" />
    </div>
    <van-overlay :show="showShare" z-index="100" @click="showShare = false">
      <div class="wrapper">
        <div class="small-block">
          <img src="../../assets/img/pay/pay_arrow.png" />
        </div>
        <div class="block">
          <img src="../../assets/img/pay/sharre-tip.png" />
        </div>
      </div>
    </van-overlay>
    <!-- 为家人投保 -->
    <van-overlay :show="showFamily" class="family_mark">
      <div class="family_mark_box" @click.stop>
        <div class="wrapper_content">
          <img :src="`${cdnresources}/prod/images/xiangaibao/${item}.png`" v-for="(item, index) in familyList"
            :key="index" @click="showInsure(item)" />
          <van-button class="family_btn" type="info"
            color="linear-gradient(135deg, #FF8842 0%, #F41A1A 100%, #8F514A 100%)" block round @click="continuePay">
            继续支付</van-button>
        </div>
      </div>
    </van-overlay>
    <pdf-action-sheet class="baozangneirong" v-model="guaranteehide" :title="'保障计划'" :style-obj="{ height: '80%' }">
      <div class="guarantee">
        <img :src="`${cdnresources}/prod/images/xiangaibao/centent1.png`" />
      </div>
    </pdf-action-sheet>
    <!-- 特药清单 -->
    <pdf-action-sheet class="baozangneirong" v-model="teyaoqingdanhide" :title="'药品清单'" :style-obj="{ height: '80%' }">
      <div class="guarantee">
        <DetailedListTable />
        <!-- <img
          :src="`${cdnresources}/prod/images/xiangaibao/yaopinqingdan.png`"
        /> -->
      </div>
    </pdf-action-sheet>
  </div>
</template>
<script>
import { AppCode } from '@/util/auth'
import rrwebSDK from '@/util/rrweb.sdk-1.2.0'
import { SetLeChengShare } from '@/util/set-wx-share'
// import { getUrlParams } from '@/util/validate'
import { gethttpurl, getDeviceInfo } from '@/util/tools'
import { baoxian } from '@/util/enum-data'
import { getSystemTime, getPaymentUrl, updatePhone } from '@/api/user.js'
import { cdnresources, CustomerServiceLink2 } from '@/util/config'
import { NewUserInsureWithOrder } from '@/api/insurance'
import { homepageresources } from '../../api/company-appointment'
import PdfActionSheet from '@/views/PdfFiles/PdfActionSheet'
import TermAgreement from './component/TermAgreement.vue'
import CommonProblem from './component/CommonProblem.vue'
import BottomCompany from './component/BottomCompany.vue'
import InsuredInformation from './component/InsuredInformation.vue'
import DetailedListTable from './component/DetailedListTable.vue'
// import explain from './component/explain.vue'
import supply from './component/supply.vue'
import { Toast } from 'vant'
import {
  WechatUserBindPhone,
  getThirdUserInfo,
  GetVerificationCode
} from '@/api/user'
import { SetGetAuthInfo } from '@/util/auth'
import modules from './insureBuy'
import marqueeVue from '../../components/marquee.vue'
import { dataList } from '@/assets/insureData'

export default {
  name: 'AreaInsuBuyDetail',
  filters: {
    calculatemoney(e) {
      return e === 0 ? 139 : 139 * e
    }
  },
  components: {
    PdfActionSheet,
    //ProductFeatures,  // 产品特色
    CommonProblem, // 常见问题
    InsuredInformation, // 参保
    TermAgreement, // 协议条款
    BottomCompany, // 底部公司
    // explain,
    supply,
    // eslint-disable-next-line vue/no-unused-components
    DetailedListTable,
    marqueeVue
  },
  mixins: [],
  props: {},
  data() {
    return {
      dataList: dataList,
      thridOpenId: '', // 小程序带过来的openId
      modules,
      isCilck: true,
      rrwebsdk: null,
      baoxian,
      baosi: 'HN22001',
      showShare: false, // 分享控制
      cdnresources,
      infoChecked: false, // 阅读条款
      errResPerson: '', // H5环境中的提示报错的人员
      DialogH5Flag: false, // H5环境中的报错显示隐藏
      guaranteehide: false, // 保障内容
      teyaoqingdanhide: false, // 特药清单
      DeviceInfo: {}, // 环境信息
      systemTime: new Date().getTime(),
      goodsMaterials: [],
      active: '',
      datalist: {
        goodsMaterials: [
          {
            path: ''
          }
        ]
      },
      peopleNum: 0,
      productStatus: '',
      caseActive: 'case1',
      showInfo: false,
      isError: false, // 验证码错误
      captcha: '',
      veriTipText: '获取验证码',
      codeDisabled: false,
      infoList: [
        { title: '姓名:', code: 'appntName', value: '' },
        { title: '证件号码:', code: 'appntIdNo', value: '' },
        { title: '手机号码:', code: 'appntMobileNumber', value: '' },
        { title: '保费合计:', code: 'payAmount', value: '' }
      ],
      claimActive: 0,
      claimList: [
        {
          title: '出险报案',
          text: '在湖南爱民保微信公众号个人中心，点击理赔申请。'
        },
        {
          title: '提交资料',
          text:
            '请按要求填写相关信息，提交相关报销材料单据照片，并确保上传资料的清晰可辨认。'
        },
        {
          title: '案件处理',
          text: '理赔人员根据案件具体情况进行审核。'
        },
        {
          title: '支付赔款',
          text: '案件审核完毕后，将为您支付理赔款。'
        }
      ],
      showFamily: false,
      showFamilyFlag: true,
      familyList: [
        'familyTitle',
        'familyChildren',
        'familySpouse',
        'familyParent'
      ],
      scrollEle: '',
      isRenewal: '10',
      updatePhone: false,
      loading: false
    }
  },
  computed: {
    aliTip() {
      let codeList = ['yxhb00000173', 'yxhb00000211']
      return codeList.includes(gethttpurl('fromSourceCode'))
    },
    changshaTip() {
      let codeList = ['yxhb00000264']
      return codeList.includes(gethttpurl('fromSourceCode'))
    }
  },
  watch: {},
  beforeCreate() { },
  async created() {
    try {
      const { goodsExt } = await homepageresources()
      if (goodsExt.SALE_STATUS == 'D') {
        this.$router.replace({ path: '/end' })
      }
    } catch (error) {
      console.log(error)
    }
    this.dataList = this.randomSortArray(this.dataList)
    this.rrwebsdk = new rrwebSDK()
    this.rrwebsdk.start() // 开始录制
    // 开始录制
    this.rrwebsdk.report({
      goodsName: '湖南爱民保2022', // 产品名称
      goodsCode: 'HNAMB2022', // 产品编码
      origin: 'HMB', // 来源，可在后台字典中配置
      goodsVersion: '1.0.0'
    })
    this.baosi = gethttpurl('baosicode') || process.env.VUE_APP_BAOSICODE
    this.DeviceInfo = getDeviceInfo()
    // 对接我的长沙小程序
    if (this.$isMini) {
      this.thridOpenId = gethttpurl('thridOpenId')
      sessionStorage.setItem('thridOpenId', this.thridOpenId)
    }
  },
  beforeMount() { },
  async mounted() {
    const isRenewal = gethttpurl('isRenewal')
    if (isRenewal) {
      this.isRenewal = isRenewal
    }
    SetLeChengShare() // 分享
    const res = await homepageresources()
    this.datalist = res
    await this.getNowTime()
  },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  methods: {
    randomSortArray(arr) {
      var stack = []
      while (arr.length) {
        //Math.random()：返回 [0,1) 之间的一个随机数
        var index = parseInt(Math.random() * arr.length) // 利用数组长度生成随机索引值
        stack.push(arr[index]) // 将随机索引对应的数组元素添加到新的数组中
        arr.splice(index, 1) // 删除原数组中随机生成的元素
      }
      return stack
    },
    async getcode() {
      await GetVerificationCode({
        mobilePhone: this.infoList[2].value
      })
      this.veriTipText = '120s后重新获取'
      this.codeDisabled = true
      let num = 120
      this.veriInterval = setInterval(() => {
        num--
        if (num > 0) {
          this.veriTipText = num + 's后重新获取'
        } else {
          clearInterval(this.veriInterval)
          this.veriTipText = '获取验证码'
          this.veriInterval = null
          this.codeDisabled = false
        }
      }, 1000)
    },
    async getSmsCode(val) {
      this.isError = false
      this.captcha = val
      let info = this.$refs.formData.getVal()
      try {
        if (
          this.DeviceInfo.env === 'wechat'
          // && gethttpurl('fromSourceCode') !== 'yxhb00000304'
        ) {
          // 先修改手机号之后再绑定
          let res = {}
          const params = {
            mobilePhone: info.data.appntMobileNumber,
            captcha: val,
            openId: SetGetAuthInfo.getInfo().openId
          }
          if (!this.updatePhone) {
            res = await WechatUserBindPhone(params)
          } else {
            res = await updatePhone(params)
          }

          // 神策埋点
          if (info.data.appntMobileNumber) {
            let response = await getThirdUserInfo({
              mobilePhone: info.data.appntMobileNumber
            })
            this.$sensors.login({
              platformCode: this.$store.state.deviceInfo.env,
              appCode: process.env.VUE_APP_BAOSICODE,
              deviceId: localStorage.getItem('anonymous_id'),
              distinctId: localStorage.getItem('distinct_id'),
              userId: response
            })
          }
          SetGetAuthInfo.setInfo(res)
          this.$store.commit('SET_USER_INFO', res)
          this.updatePhone = false
        }
        this.testFn()
      } catch (error) {
        this.$toast(error.message)
        this.isError = true
        this.captcha = ''
      }
    },
    closedInfo() {
      this.isError = true
      this.showInfo = false
      this.captcha = ''
    },
    teyaoqingdanclick() {
      this.teyaoqingdanhide = true
    },
    // 客服链接
    goConsult() {
      let rest = JSON.parse(localStorage.getItem('wxinfor'))
      let datainfor = {
        userNickname: rest && rest.userName ? rest.userName : '', // 微信昵称
        trueName: this.$refs.formData.getVal().data.appntName, // 用户名
        phone:
          rest && rest.mobilePhone
            ? rest.mobilePhone
            : this.$refs.formData.getVal().data.appntMobileNumber // 手机号
      }
      datainfor.phone = datainfor.phone || '该客户未留手机号'
      localStorage.setItem('visitorinfor', JSON.stringify(datainfor))
      // location.href = `${CustomerServiceLink}?baosicode=${
      //   this.baosi
      // }&fromSourceCode=${getUrlParams('fromSourceCode')}`
      location.href = CustomerServiceLink2
    },
    getXfzIndex() {
      this.$nextTick(() => {
        return {
          xfzIndex: this.$refs.formData.xfzIndex
        }
      })
    },
    async setXfzIndex() {
      let getXfzRes = await this.$refs.formData.getXfz()
      if (getXfzRes == 'false') return
    },
    consentclause(v, xfz) {
      this.infoChecked = v
      if (xfz) {
        this.setXfzIndex()
      }
    },
    // 获取服务器时间
    async getNowTime() {
      try {
        const res = await getSystemTime()
        console.log('系统时间:', res)
        this.systemTime = res
      } catch (e) {
        this.$toast(e.message)
      }
    },
    getNum(data) {
      this.peopleNum = data.length
    },
    async onActive(name, title) {
      if (title === '我要投保') {
        let getXfzRes = await this.$refs.formData.getXfz()
        if (getXfzRes == 'false') return
      }
    },
    gotoSubmit() {
      document.getElementById('a').scrollIntoView()
    },
    // 为家人投保
    async showInsure(v) {
      await this.$refs.formData.addInfo()
      this.showFamily = false
      let index = this.$refs.formData.getVal().userInfo.length - 1
      switch (v) {
        case 'familyChildren':
          this.$refs.formData.getActive('children', index)
          break
        case 'familySpouse':
          this.$refs.formData.getActive('spouse', index)
          break
        case 'familyParent':
          this.$refs.formData.getActive('parent', index)
          break
      }
      let nums = document.getElementsByClassName('userForm').length
      document.getElementsByClassName('userForm')[nums - 1].scrollIntoView()
      let scrollEle = document.getElementsByTagName('html')[0].scrollTop
        ? document.getElementsByTagName('html')[0]
        : document.getElementsByTagName('body')[0]
      scrollEle.scrollTop = scrollEle.scrollTop - 110
    },
    // 继续支付
    continuePay() {
      this.showFamily = false
      this.showFamilyFlag = false
      this.submit()
    },
    //立即投保状态控制
    async testFn() {
      this.productStatus = this.$store.state.productStatus
      switch (this.productStatus) {
        case 'B':
          this.$toast({
            message: '产品备案中，敬请期待！',
            duration: 2000
          })
          break
        case 'D':
          this.$toast({
            message: '参保时间已过，感谢您的关注！',
            duration: 2000
          })
          break
        default:
          this.submit()
          break
      }
    },
    async submit() {
      let that = this
      this.$refs.scrollTab.scrollTo(3)
      let childrenRes = this.$refs.formData.getVal()
      let getXfzRes = await this.$refs.formData.getXfz()
      if (getXfzRes == 'false') return
      try {
        await this.$refs.formData.$refs.appntForm.validate()
        let scrollEle = document.getElementsByTagName('html')[0].scrollTop
          ? document.getElementsByTagName('html')[0]
          : document.getElementsByTagName('body')[0]
        if (childrenRes.userInfo.length > 0) {
          for (let index = 0; index < childrenRes.userInfo.length; index++) {
            this.$refs.formData.formObjIndex = index
            await this.$refs.formData.$refs.userForm[index].validate()
          }
        } else {
          Toast('请先添加被保人')
          return false
        }
        this.getNum(childrenRes.userInfo)
        let params = {
          appntIdNo: childrenRes.data.appntIdNo, // 证件号
          appntIdType: childrenRes.data.appntIdType, // 证件类型
          appntMobileNumber: childrenRes.data.appntMobileNumber, // 购买人手机号
          appntName: childrenRes.data.appntName, // 购买人姓名
          captcha: this.captcha, //验证码
          fromSourceCode: gethttpurl('fromSourceCode') || 'qmhb', // 推广渠道，从url上获取，默认 qmhb
          thirdUserId: gethttpurl('thridUID') || '',
          reserveData1:
            gethttpurl('qz_gdt') || this.$route.query.qz_gdt || '',
          insuranceCompany: baoxian[this.baosi], // 对接保司，后端定义好约定
          insurancePeriod: '1', // 固定值
          insurancePlanCode: this.baosi, //产品编码，后端定义好约定
          insuranceProductCode: this.baosi, //产品编码，后端定义好约定
          insuredFeeAmount: '29', // 保费
          insuredAmount: 1000000, // 保额
          insuredDateFlag: 'Y', // 固定值
          isAdvancePayment: childrenRes.data.isAdvancePayment,
          insuredPersonIdNo: childrenRes.userInfo[0].userCardNo, // 第一个参保人证件号
          insuredPersonIdType: childrenRes.userInfo[0].userCardType, // 第一个参保人证件类型
          insuredPersonMobileNumber: childrenRes.data.appntMobileNumber, // 第一个参保人手机号
          insuredPersonName: childrenRes.userInfo[0].userName, // 第一个参保人姓名
          insuredTotalAmount: 1000000, // 第一个参保人保额
          isCallBackFlag: AppCode, // appcode
          isExternalUser: this.DeviceInfo.env === 'wechat' ? '0' : '1', // 根据h5或微信环境判断，h5用1，微信用0
          numbers: 1, // 固定值
          operatorUserId: '', // 当前用户的openId
          payAmount: this.peopleNum * 139, // 保费
          payFrequencyFlag: 'Y', // 固定值
          payFrequencyNumber: '1', // 固定值
          userInsurePersonList: [
            {
              insuredRelation: 'oneself', //  购买人关系
              personnelType: 'policyHolder', //  区分购买人policyHolder，insured参保人
              userBirthday: childrenRes.data.userBirthday, //   出生日期
              userCardNo: childrenRes.data.appntIdNo, // 证件号
              userCardType: childrenRes.data.appntIdType, // 证件类型
              userMobile: childrenRes.data.appntMobileNumber, // 手机号
              userName: childrenRes.data.appntName, //  姓名
              userSex: childrenRes.data.userSex // 性别
            },
            ...childrenRes.userInfo
          ],
          isRenewal: this.isRenewal
        }
        if (params.isAdvancePayment == '') {
          document.getElementById('isAdvancePayment').scrollIntoView()
          scrollEle.scrollTop = scrollEle.scrollTop - 110
          this.$dialog
            .confirm({
              title: '温馨提示',
              message: '建议开通自动提醒,以免错失下一年保障!',
              theme: 'round-button',
              confirmButtonText: '开通',
              confirmButtonColor: '#FF6E3D',
              cancelButtonText: '不开通',
              cancelButtonColor: '#cdcdcd'
            })
            .then(() => {
              that.$refs.formData.formData.isAdvancePayment = '10'
              if (that.$refs.formData.firstClick == 1) {
                // that.$refs.formData.clickAuto()
                that.$refs.formData.firstClick = 2
              }
            })
            .catch(() => {
              that.$refs.formData.formData.isAdvancePayment = '20'
            })
          return
        }
        if (!this.infoChecked) {
          document.getElementById('termAgree').scrollIntoView()
          Toast('请认真阅读协议并勾选')
          return
        }
        if (
          params.userInsurePersonList.length === 2 &&
          params.userInsurePersonList[0].insuredRelation === 'oneself' &&
          params.userInsurePersonList[1].insuredRelation === 'oneself' &&
          this.showFamilyFlag
        ) {
          this.showFamily = true
          return
        }
        this.infoList.map(item => {
          item.value = params[item.code] ? params[item.code] : ''
        })
        const mobilePhone = SetGetAuthInfo.getInfo().mobilePhone
        const inputPhone = childrenRes.data.appntMobileNumber

        if (this.captcha == '') {
          let flag = this.DeviceInfo.env === 'wechat' && mobilePhone
          if (!flag) {
            this.showInfo = true
            this.$nextTick(() => {
              if (this.veriTipText == '获取验证码') {
                scrollEle.scrollTop = scrollEle.scrollTop + 180
                this.getcode()
              }
            })
            return false
          } else {
            if (inputPhone !== mobilePhone) {
              this.showInfo = true
              this.updatePhone = true
              return
            }
          }
        }
        this.loading = true
        const newInsuRes = await NewUserInsureWithOrder(params)
        if (newInsuRes.payOrder && newInsuRes.payOrder.orderSn) {
          this.$toast({
            forbidClick: true,
            type: 'success',
            message: '提交成功',
            onClose: async () => {
              // 订单提交成功把参数储存起来
              let parameter = JSON.stringify(gethttpurl())
              localStorage.setItem('parameter', parameter)
              // 上报
              this.rrwebsdk.report({
                applicantName: params.appntName, // 投保人姓名
                idNo: params.appntIdNo, // 投保人证件号
                orderNo: newInsuRes.payOrder.orderSn, // 订单号
                goodsVersion: '1.0.0'
              })
              // 埋点功能 ---  支付成功前存入当前URL 供后续埋点使用
              sessionStorage.setItem('bdPromotion', location.href)
              // 快手埋点
              if (gethttpurl('fromSourceCode') == 'market000005') {
                let data = {
                  userName: params.appntName,
                  phoneNo: params.appntMobileNumber,
                  certNo: params.appntIdNo,
                  policyNo: newInsuRes.payOrder.orderSn
                }
                sessionStorage.setItem('KSParams', JSON.stringify(data))
              }
              // 前往支付
              // 对接小程序
              this.closedInfo()
              let openid = ''
              let res = ''
              let orderSn = newInsuRes.payOrder.orderSn
              if (this.$isMini) {
                switch (gethttpurl('fromSourceCode')) {
                  case 'yxhb00000304':
                    openid = this.thridOpenId
                    res = await this.getPaymentUrl(orderSn, openid)
                    window.wx.miniProgram.navigateTo({
                      url: `/pages/payPage/payPage?data=${encodeURIComponent(
                        res
                      )}`
                    })
                    break
                  case 'yxhb00000362':
                    openid = this.thridOpenId
                    res = await this.getPaymentUrl(orderSn, openid)
                    window.wx.miniProgram.navigateTo({
                      url: `/pages/third-pay/payPage?data=${encodeURIComponent(
                        res
                      )}`
                    })
                    break
                  default:
                    openid = this.$store.state.userInfo.openId || ''
                    res = await this.getPaymentUrl(orderSn, openid)
                    this.rrwebsdk.leaveReport(() => {
                      window.location.href = res
                    })
                    break
                }
              } else {
                openid = this.$store.state.userInfo.openId || ''
                res = await this.getPaymentUrl(orderSn, openid)
                this.rrwebsdk.leaveReport(() => {
                  window.location.href = res
                })
              }
            }
          })
        } else {
          this.$toast(newInsuRes.remark)
          this.isError = true
          this.captcha = ''
        }
      } catch (e) {
        let scrollEle = document.getElementsByTagName('html')[0].scrollTop
          ? document.getElementsByTagName('html')[0]
          : document.getElementsByTagName('body')[0]
        if (e instanceof Array) {
          if (
            e[0].name.includes('user') |
            e[0].name.includes('picker') |
            e[0].name.includes('insuredRelation')
          ) {
            let indexFlag = this.$refs.formData.formObjIndex
            this.$refs.formData.$refs.userForm[indexFlag].scrollToField(
              e[0].name,
              true
            )
          } else {
            this.$refs.formData.$refs.appntForm.scrollToField(e[0].name, true)
          }
          this.$toast(e[0].message)
          console.log('scrollEle.scrollTop', scrollEle.scrollTop)
          scrollEle.scrollTop = scrollEle.scrollTop - 110
        } else {
          if (e.message.indexOf(':') === -1) {
            let msg = e.message
            if (msg.indexOf('insuranceCompany') !== -1) {
              this.$dialog({
                title: '提示',
                message: '产品编码不对，请打开正确的链接'
              })
            } else {
              this.$dialog({ title: '提示', message: e.message })
            }

            if (e.message === 'captcha不能为空') {
              this.$dialog({ title: '提示', message: '验证码不能为空' })
            }
          } else {
            const errRes = e.message.split(':')
            if (this.DeviceInfo.env === 'wechat') {
              switch (errRes[0]) {
                case 'othersOrders':
                  this.$dialog.alert({
                    title: '提示',
                    message: `已经有其他投保人为${errRes[1]}投保，无需重复下单`
                  })
                  break
                case 'waitPayOrders':
                  this.$dialog
                    .confirm({
                      title: '提示',
                      message:
                        '参保人：' +
                        errRes[1] +
                        '&nbsp;&nbsp;' +
                        '存在未支付订单，请您先支付订单',
                      confirmButtonText: '去支付'
                    })
                    .then(() => {
                      const type = 'waitPay'
                      this.$router.push({
                        path: `/user-policy/${type || ''}`
                      })
                    })
                  break
                case 'generatingOrders':
                  this.$dialog.alert({
                    title: '提示',
                    message:
                      '参保人：' +
                      errRes[1] +
                      '&nbsp;&nbsp;' +
                      '已有相关订单，请先删除相关参保人，谢谢'
                  })
              }
            } else {
              this.errResPerson = errRes[1].replace(';', '')
              this.DialogH5Flag = true
            }
          }
          this.closedInfo()
        }
      }
      this.loading = false
      let scrollEle = document.getElementsByTagName('html')[0].scrollTop
        ? document.getElementsByTagName('html')[0]
        : document.getElementsByTagName('body')[0]
      scrollEle.scrollTop = scrollEle.scrollTop - 180
    },
    async getPaymentUrl(orderSn, openId) {
      try {
        let res = await getPaymentUrl({
          orderSn: orderSn,
          openId: openId,
          payType: 'weichatAcc',
          clientPayType: 'JSAPI'
        })
        return res.paymentUrl
      } catch (error) {
        this.$toast(error.message)
      }
    }
  }
}
</script>
<style lang="scss">
.free-insurance-box {
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: xvw(200);
  position: relative;

  .marqueeVue {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }

  .banner-img-box {
    position: relative;
    width: 100%;

    img {
      width: 100%;
    }

    .marqueeBox {
      position: absolute;
      left: xvw(30);
      top: xvw(440);
      width: xvw(260);
      height: xvw(20);
    }

    .countDown {
      position: absolute;
      top: xvw(546);
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: xvw(690);
      height: xvw(108);
      left: 50%; // 关键点！！
      transform: translateX(-50%); // 关键点！！
      background: linear-gradient(180deg, #ff9257 0%, #f52b27 100%);
      border-radius: 49px 49px 49px 0px;
    }

    .lijitoubao {
      position: absolute;
      bottom: xvw(40);
      left: 50%; // 关键点！！
      transform: translateX(-50%); // 关键点！！
      height: xvw(136);
      width: xvw(576);
    }

    .point {
      position: absolute;
      width: xvw(120);
      bottom: xvw(40);
      right: 80px;
      animation: mymove 1s infinite;
    }

    @keyframes mymove {
      0% {
        bottom: xvw(40);
        right: 80px;
      }

      50% {
        bottom: xvw(20);
        right: 90px;
      }

      100% {
        bottom: xvw(40);
        right: 80px;
      }
    }
  }

  .production-list {
    text-align: center;
    margin-bottom: xvw(20);

    p {
      margin: 0px;
      padding: 0px;
    }

    img {
      width: 100%;
      margin-top: px2rem(10);
    }
  }

  .claim_des {
    padding: xvw(32);

    .claim_des_title {
      display: flex;
      align-items: center;

      .claim_des_line {
        margin-right: xvw(8);
        width: xvw(7);
        height: xvw(40);
        background: linear-gradient(180deg,
            #ff2340 0%,
            #d62021 99%,
            #ffffff 100%);
        border-radius: xvw(5);
      }
    }

    .van-tabs {
      margin: xvw(30) 0;

      .van-tabs__line {
        background: none;
        width: 0px;
        height: 0px;
        border-bottom: xvw(30) solid #ffffff;
        border-left: xvw(20) solid transparent;
        border-right: xvw(20) solid transparent;
        bottom: xvw(20);
        z-index: 40;
      }

      .claimTabActive {
        background: url('~@/assets/img/insu_detail/claimTabActive.png') no-repeat;
        background-size: 100%;
      }

      .claimTab {
        background: url('~@/assets/img/insu_detail/claimTab.png') no-repeat;
        background-size: 100%;
      }

      .claim_des_text {
        height: xvw(140);
        background: #fffbfb;
        border-radius: 1px;
        border: 1px dashed #ff5e5e;
        font-size: xvw(26);
        font-weight: 400;
        color: #333333;
        display: flex;
        align-items: center;
        padding: 0 xvw(20);
        margin-top: xvw(20);
        box-sizing: border-box;
      }
    }
  }

  .footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 30;
    padding-bottom: env(safe-area-inset-bottom);
    background: #ffffff;

    .submit_btn {
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      .btn_left {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-shrink: 0;
        width: xvw(220);
        padding-left: xvw(20);
        box-sizing: border-box;

        .left-img {
          img {
            width: xvw(96);
            width: xvw(89);
            display: block;
            margin-left: 8px;
          }
        }
      }

      .total {
        padding-right: xvw(20);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;

        .money {
          color: #f13b41;

          span:first-child {
            font-size: px2rem(40);
          }

          span:nth-child(2) {
            font-weight: 600;
            font-size: px2rem(59);
            padding: 0 2px;
          }

          span:last-child {
            font-size: px2rem(30);
          }
        }

        .price {
          margin-top: 3px;
          font-size: px2rem(30);
          color: #666;
          text-align: center;

          span {
            color: #ff3900;
          }
        }
      }

      .btn {
        width: xvw(260);
        height: xvw(110);
        background: linear-gradient(90deg, #ffaf40, #ff7108);
        border-radius: 2px;
        font-size: xvh(38);
        font-weight: 500;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: xvw(20) 0;
        flex-shrink: 0;
      }
    }
  }

  .dialogContainer {
    max-height: 60%;
    // overflow: hidden;
  }

  .DialogH5Box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    display: inline-block;
    padding: 0 px2rem(30);
    margin-bottom: px2rem(30);
    text-align: center;
    width: 100%;
  }

  .dialogclass {
    text-align: justify;
    font-size: px2rem(15, 375);
    line-height: px2rem(20, 375);
    padding: xvw(20) xvw(30);

    .alitip_zhu {
      color: #7c7c7d;
      font-size: xvw(20);
    }
  }

  .imgclass {
    text-align: center;

    img {
      width: 60%;
    }
  }
}

.share-button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 0;
  bottom: 35%;
  z-index: 10;

  >img {
    width: xvw(200);
  }
}

.wrapper {
  height: 100%;

  .small-block {
    width: px2rem(54, 375);
    height: px2rem(63, 375);
    margin-left: 75%;
    margin-top: 3%;

    img {
      width: px2rem(54, 375);
      height: px2rem(63, 375);
      max-width: 750px;
    }
  }

  .block {
    width: px2rem(340, 375);
    // height: px2rem(126, 375);
    margin: 0 auto;

    img {
      width: px2rem(340, 375);
      // height: px2rem(126, 375);
      max-width: 750px;
    }
  }
}

/deep/.van-tabs--line .van-tabs__wrap {
  height: xvh(118);
}

/deep/.van-tab__text--ellipsis {
  font-size: xvw(32);
}

/deep/.van-tabs__line {
  height: xvh(5);
  background: #f6303b;
  border-radius: xvh(8);
}

.baozhangneirongcss {
  background: #fff;
  position: relative;

  .baozhangtop {
    width: xvw(710);
    padding: xvw(20) xvw(20);
    box-sizing: border-box;
    background: #ffffff;
    margin: xvw(30) auto;
    box-shadow: 0px 0px 9px 0px rgba(6, 147, 233, 0.18);
    border-radius: xvw(20);
    color: #4f4f4f;
    font-size: xvw(28);
    line-height: xvw(40);

    .baozhang_box {
      display: flex;
      margin-top: xvw(10);

      .left {
        width: xvw(150);
        flex-shrink: 0;
        font-weight: bolder;
      }
    }
  }

  .title_img {
    position: absolute;
    bottom: xvw(50);
    width: 140px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}

.product_List {
  .product_img {
    width: 100%;
  }

  .medicine {
    position: relative;

    .medicinebtn {
      position: absolute;
      width: xvw(359);
      height: xvw(45);
      bottom: xvw(50);
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
}

.caseTabs {
  img {
    width: 100%;
  }
}

.van-tabs {
  width: 100%;
}

.guarantee {
  padding: 0 xvw(6);
  box-sizing: border-box;

  img {
    padding: xvw(20) xvw(20);
    width: 100%;
  }

  .title {
    margin-top: xvw(0);
    text-align: center;

    img {
      width: xvw(371);
      height: xvw(61);
      padding: 0px;
    }
  }

  .tyqd-head {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: xvw(20);
    font-size: xvw(40);
    font-weight: 700;
    letter-spacing: xvw(2);

    img {
      width: xvw(100);
    }
  }

  table.tableizer-table {
    font-size: xvw(16);
    border: xvw(2) solid #696969;
    border-collapse: collapse;
    color: #696969;
  }

  .tableizer-table td {
    padding: 4px;
    margin: 3px;
    border: xvw(2) solid #696969;
    text-align: center;
  }
}

.baozangneirong .pop-title {
  line-height: 3rem;

  span {
    display: inline-block;
  }
}

.info_popup {
  width: xvw(700);

  .info_title {
    display: flex;
    justify-content: center;
    padding: xvw(20);
    color: #ffffff;
    background: linear-gradient(135deg,
        #ff8842 0%,
        #f41a1a 100%,
        #8f514a 100%);
    position: relative;

    .closeIcon {
      display: block;
      width: xvw(44);
      position: absolute;
      right: xvw(20);
    }
  }

  .info_des {
    font-size: xvw(28);
    font-weight: 400;
    color: #666666;
    line-height: xvw(44);
    padding: xvw(20);
  }

  .infoList {
    color: rgb(177, 177, 177);
    padding: xvw(20) xvw(40);

    .info_item {
      display: flex;
      align-items: center;
      height: xvw(80);

      .item_left {
        width: xvw(200);
      }

      .item_right {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .van-button {
          width: xvw(200);
          height: xvw(50);
        }
      }
    }
  }

  .sms-check-code-wrapper {
    .sms-code-container {
      padding: xvw(20) 0 xvw(40);
      border-top: xvw(1) solid rgb(177, 177, 177);

      .sms-code-box {
        position: relative;
        height: xvw(70);

        .sms-code-input-box {
          padding-top: 0;
          text-align: left;
        }
      }
    }
  }
}

.family_mark {
  z-index: 100;

  .family_mark_box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .wrapper_content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #ffffff;
      padding: xvw(50);
      border-radius: xvw(16);

      img {
        width: xvw(540);
        height: xvw(130);
        margin-top: xvw(20);

        &:nth-child(1) {
          width: xvw(340);
          height: xvw(54);
          margin-bottom: xvw(40);
        }
      }

      .family_btn {
        margin-top: xvw(40);
      }
    }
  }
}
</style>
